import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import translationsActions from 'actions/translations';
import featureFlaggingActions from 'actions/featureFlagging';
import globalErrorModalActions from 'actions/globalErrorModalActions';
import { actions as formActions } from 'react-redux-form';
import withFeatureToggling from '../../hocs/withFeatureToggling/withFeatureToggling';
import { App } from './App';

export const AppContainer = connect(
    state => ({
        translations: state.translations,
        globalErrorModal: state.globalErrorModal,
    }),
    dispatch => ({
        translationsActions: bindActionCreators(translationsActions, dispatch),
        globalErrorModalActions: bindActionCreators(globalErrorModalActions, dispatch),
        featureFlaggingActions: bindActionCreators(featureFlaggingActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(withFeatureToggling(App));
